import { Component } from "@angular/core";
import { PonderTasksClient } from "@apiserver-rest/ponder-tasks-client";
import { GetImportUserCollectionResultsResponse, UserCollectionImportTaskStatus } from "@apiserver-rest/ponder-tasks-client-base";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { Subscription, take } from "rxjs";
import { ImportCollectionResultRowComponent } from "./import-collection-result-row.component";
import { EventBroker } from "@ponder-core/events/eventBroker";

@Component({
    selector: "import-collection-results",
    imports: [LoadingComponent, ImportCollectionResultRowComponent],
    templateUrl: "./import-collection-results.component.html"
})
export class ImportCollectionResultsComponent {
    public isLoading: boolean = true;
    public loadingSuccess: boolean = false;
    public results?: UserCollectionImportTaskStatus[];

    private collectionImportedSub!: Subscription;

    public constructor(private ponderTasksClient: PonderTasksClient, events: EventBroker) {
        this.collectionImportedSub = events.collection
            .collectionImportedEvent
            .subscribe({
                next: (status: UserCollectionImportTaskStatus) => {
                    if (!this.results) {
                        this.results = [];
                    }

                    this.results.push(status);
                    this.sortResults();
                    this.handlePendingStatusRefresh();
                }
            });
    }

    public ngOnDestroy(): void {
        this.collectionImportedSub.unsubscribe();
    }

    public ngOnInit(): void {
        this.refreshResults();
    }

    private sortResults(): void {
        this.results?.sort((a, b) => b.startedAt.getTime() - a.startedAt.getTime());
    }

    /**
     * Pulls the collection import results for the current user.
     */
    private refreshResults(): void {
        this.ponderTasksClient
            .userCollectionImportResults()
            .pipe(take(1))
            .subscribe({
                next: (response: GetImportUserCollectionResultsResponse) => {
                    if (response.success) {
                        this.loadingSuccess = true;
                        this.results = response.results;

                        this.sortResults();
                        this.handlePendingStatusRefresh();
                    }
                }
            })
            .add(() => { this.isLoading = false; });
    }

    /**
     * Checks if any of the collection imports are pending.
     * If so, sets a callback to refresh the results in 5 seconds.
     */
    private handlePendingStatusRefresh(): void {
        if (!this.results?.length) {
            return;
        }
        
        var hasPending: boolean = false;

        for (let i = 0; i < this.results.length; ++i) {
            if (this.results[i].isPending) {
                hasPending = true;
                break;
            }
        }
        
        if (!hasPending) {
            return;
        }

        setTimeout(() => {
            this.refreshResults();
        }, 5000);
    }
}